import slSI from '../../date-picker/locale/sl_SI';
export default slSI;
